import script from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"

import "./PrestPopupVariantPierreVacance.vue?vue&type=style&index=0&id=eb5774be&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb5774be"]])

export default __exports__